module.exports = __webpack_public_path__ + "static/media/ev2.d83e2de1.jpg";